module.exports = require("vtk.js/Sources/Rendering/Core/InteractorStyle/Constants");